import React from 'react';
import styles from './TabsHorizontal.module.scss';

export const TabContainer = ({ children }) => {
  // Holds row of tabs and overflowing tabs that do not fit will
  // either be hidden in a display more or overflow to next row
  return <div className={styles.container}>{children}</div>;
};
